import { useCallback } from 'react';
import cl from 'classnames';
import get from 'lodash/get';
import omit from 'lodash/omit';

import { FilterBadgeProps } from '../types';
import { GADataType } from '../../../types';
import { IconsEnum } from '../../../assets/icons/types';

import { Translate } from '../../Translate';
import { PureIconButtonHelper } from '../../buttons/PureIconButtonHelper';

interface BooleanFilterBadgeProps extends FilterBadgeProps {
  falseValue?: boolean;
  nullValue?: boolean;
  isDefaultValue?: boolean;
}

function BooleanFilterBadge({
  dataGa,
  falseValue,
  filterField,
  filters,
  i18nLabel,
  isDefaultValue,
  name,
  nullValue,
  onRemoveFilter
}: BooleanFilterBadgeProps & GADataType) {
  const handleRemoveFilter = useCallback(() => {
    onRemoveFilter(omit(filters, name));
  }, [onRemoveFilter, filters, name]);

  const value = get(filters, filterField ? [name, filterField] : name);

  const isVisible = nullValue
    ? name in filters && value === null
    : falseValue
    ? value === false
    : value;

  return isVisible ? (
    <span
      className={cl(
        ' bg-opacity-20 dark:text-gray-200 inline-flex items-center m-0.5 px-3 py-1.5 rounded-md text-gray-800 text-sm',
        isDefaultValue ? 'bg-gray-500/20' : 'bg-blue-500'
      )}
    >
      <Translate id={i18nLabel || name} />
      <PureIconButtonHelper
        className="flex-shrink-0 ml-1 -my-1 -mr-2 h-6 w-6 rounded inline-flex items-center justify-center text-gray-800 dark:text-gray-200 hover:bg-gray-500 hover:bg-opacity-20 hover:text-gray-700 dark:hover:bg-opacity-20 dark:hover:bg-white dark:hover:text-white"
        dataGa={dataGa}
        icon={IconsEnum.X}
        iconClassName="h-3.5 w-3.5"
        onClick={handleRemoveFilter}
      />
    </span>
  ) : null;
}

export default BooleanFilterBadge;
